<template>
  <el-container style="height: 100% ;overflow: hidden">
    <el-header class="sys-header">
      <div class="titleContainer">
        <span class="sys-header-icon">
          <!-- <img :src="headImg" alt="" style="font-size:28px" class="iconfont">  -->
          <!-- <i class="iconfont iconzhengjitubiao-tuolaji" style="font-size:28px"/> -->
        </span>
        <!-- <span class="sys-header-title">辽宁省新型经营主体名录库管理系统</span> -->
        <span class="sys-header-title">{{appName}}</span>
        <!-- {{username}}-->
      </div>
      <div class="userContainer">
        <!-- <el-date-picker
          v-model="selectedYear"
          type="year"
          size="small"
          :picker-options="pickerOptions"
          class="header_year_picker"
          :clearable="false"
          placeholder="选择年">
        </el-date-picker>
        <span style="font-size:16px;">&nbsp;|&nbsp;</span> -->
        <div class="user_btn_box">
          <el-dropdown style="line-height: 60px;" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-caret-bottom el-icon--right el-icon-user-solid user-btn"></i>
              {{username}}
              <i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-remove" command="editpwd">修改密码</el-dropdown-item>
              <el-dropdown-item icon="el-icon-remove" command="logout">退出登录</el-dropdown-item>
              <el-dropdown-item icon="el-icon-remove" command="goDashboard">返回首页</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </el-header>
    <el-container style="height: calc(100% - 60px);">
      <!--主菜单-->
      <div class="aside" style="float: left;">
        <div class="collapseContainer">
          <i
            id="collapse"
            @click="menuCollapse"
            v-bind:class="{ menuActive: isCollapsed }"
            class="el-icon-s-unfold"
          ></i>
        </div>
        <!-- 菜单栏合并为一列，二级菜单在对应的一级菜单下方，可收起、展开 -->
        <el-menu
          class="el-menu-vertical-demo"
          :collapse="isCollapsed"
          background-color="#fff"
          text-color="#646464"
          active-text-color="#fff"
          :unique-opened="true"
          :default-active="$route.path"
          :router="true"
        >
          <el-submenu
            v-for="menuItem in menus_1"
            class="my-root-menu-item"
            :index="menuItem.menuUrl"
            :key="menuItem.id"
          >
            <template slot="title">
              <img width="20" height="20" :src="menuItem.icon && menuItem.icon.split('?')[0]" alt="">
              <span slot="title">{{menuItem.name}}</span>
            </template>
            <el-menu-item
              v-for="subItem in menuItem.menuVoList"
              :index="subItem.menuUrl"
              :key="subItem.name"
            >{{subItem.name}}</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div style="width:100%;overflow: hidden;height: 100%;background-color:#f8f9fa;">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
      </div>
    </el-container>
  </el-container>
</template>
<script>
import Cookies from "js-cookie";
import API_config from "../api/configuration/api_configuration"
import base64 from "../common/base64";
 import menusData from "../static/menus.json"
// import API from "@/api/projectManagement/api_projectManagement";

export default {
  name: "Home",
  data() {
    return {
      userIcon: "../../static/img/img_tx.jpg",
      isCollapsed: true,
      appName:Cookies.get('appName'),
      username: Cookies.get("accountName"),
      areaCode: Cookies.get("curAreaCode"),
      checkList: [],
      headImg:require('../../static/img/logohead.png'),
      //菜单
      menus_1: [],
      activeMenu: [],
      //当前激活的主菜单
      activeIndex: "",
      projectId: "", // 项目名称ID
      projectName: "", // 项目名称ID
      projectList: [{
        number:"",
        name:"全部"
      }],
      projectBak: {
        number:"1",
        name:"其他"
      },
      selectedYear: new Date().getFullYear().toString(),
      pickerOptions: {
        disabledDate(time) { return time.getFullYear() > new Date().getFullYear() ;}}
      };
  },
  created() {
    let menus = JSON.parse(localStorage.getItem("menus"));
    menus.forEach(element => {
      if(element.name == '首页') {
        element.sort = 0
      }
    })

    menus.sort((a, b)=>{
      return a.sort - b.sort
    })

    this.getSysInfo();
    if (menus) {
      this.menus_1 = menus || [];
      let mainPath = menus[0].menuVoList[0].menuUrl;
      if(this.$route.name!=='home') return
      Cookies.set('mainPath',mainPath);
      this.$nextTick(()=>{
        this.$router.push(mainPath)
      })
    }
  },
  methods: {
    handleCommand(command) {
      if (command == "logout") {
        this.logout();
      } else if (command == 'goDashboard') {
        this.goDashboard()
      }
    },
    logout: function () {
      let that = this;
      this.$confirm("是否要注销当前登录" + this.username + "用户?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.$router.push({ path: "/login" });
        })
        .catch(() => {});
    },
    goDashboard() {
      this.$router.push({ path: "/homepage/home" });
    },
    // 获取定制化的系统标题
    getSysInfo(){
      API_config.applicationDicDetail({qhdm:this.areaCode}).then(res=>{
        if(res.code===0){
            this.appName= res.data.detail.name
            localStorage.setItem('userSysInfoAppName', res.data.detail.name)
        }
      })
    },
    //菜单开关
    menuCollapse() {
      this.GLOBAL.eventBus.$emit("winSizeChange");
      this.isCollapsed = !this.isCollapsed;
      let that = this;
      if (that.GLOBAL.map) {
        setTimeout(() => {
          that.GLOBAL.map.resize();
        }, 400);
      }
    },

    /*跳转到大屏*/
    to_big_screen() {
      this.$router.push({ path: "/bigScreen" });
    },
  },
};
</script>

<style lang="less" scoped>
@themeColor: #0dc98e;
.aside {
  height: 100%;
}

.my-root-menu-item i {
  color: #646464;
}
.my-root-menu-item.is-active span,
.my-root-menu-item.is-active i {
  color: @themeColor;
}

.my-submenu-title,
.el-menu > .el-submenu > .el-submenu__title {
  background-color: #ffefef !important;
}

.el-menu-vertical-demo {
  border: none;
  overflow-y: auto;
}

.el-menu-vertical-demo,
.sub-menu {
  height: calc(100% - 40px);
}
.iconfont{
  height: 60%;
  vertical-align: middle;
  // width: 100%;
}


.sys-header {
  background-color: #0EAC79;
  //  background: linear-gradient(to right, #262d38, #727270);
  height: 50px;
  vertical-align: middle;
}

.sys-header{
  .titleContainer {
    float: left;
    line-height: 60px;
    height: 100%;
    width: 80%;
    .sys-header-title {
      font-weight: bold;
      font-size: 22px;
      color: #fff;
      line-height: 60px;
      display: inline-block;
      vertical-align: top;
    }
    .sys-header-icon {
      font-size: 28px;
      color: #fff;
    }
  }
  .userContainer {
    // height: 100%;
    display: flex;
    align-items:center;
    text-align: right;
    font-size: 28px;
    color: #fff;
    position: absolute;
    right: 20px;
    .el-dropdown-link{
      cursor: pointer;
      color: #fff;
      font-size: 18px;
      &:hover{
        color: #00ffff;
      }
      .user-btn{
        position: relative;
        font-size: 20px;
        margin:0 0 0 10px;
      }
    }
  }
}
.sys-header .userContainer .el-dropdown-link

.menuActive {
  transform: rotate(90deg);
}

.collapseContainer {
  height: 20px;
  text-align: center;
  background-color: #fff;
  padding: 10px 0;
  i {
    color: #646464;
  }
}

.el-submenu .el-menu-item {
  padding-left: 70px !important;
  font-weight: 600;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.el-menu-vertical-demo {
  height: calc(100% - 40px);
}

.group {
  font-size: 14px;
}

/*子菜单样式*/
.my-submenu {
  height: 100%;
  .menu-title {
    color: #363434;
    text-align: left;
    padding: 5px;
    height: 35px;
    border-bottom: 1px solid #cebdbd;
    font-weight: bold;
  }
  .my-submenu-main {
    height: calc(100% - 55px);
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 10px;
  }
}

.my-submenu:not(.el-menu--collapse) {
  width: 180px;
}

.my-submenu .menu-title i,
.my-submenu .menu-title span {
  vertical-align: middle;
  line-height: 35px;
}

/*不明白为什么注掉这块菜单设置先加上20200428 哈哈*/
.my-submenu .el-menu-item:focus,
.my-submenu .el-menu-item:hover,
.my-submenu .el-menu-item.is-active {
  outline: 0;
  background-color: #fdf6ec;
  color: #e6a23c !important;
  border-left: solid 3px #ff5b5b;
}

/*有子级的菜单背景色*/
.el-menu /deep/ .el-submenu .el-submenu__title {
  font-weight: 600;
}

.el-menu /deep/ .el-submenu.is-active .el-submenu__title{
  background-color: rgba(144, 131, 155, 0.23) !important;
}

/*子菜单打开、收起动画*/
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.4s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

/*.el-tabs__header {
    !*tab选中下划线颜色*!
    .el-tabs__active-bar.is-top {
      background-color: red;
    }
    !*tab选中文字颜色*!
    .el-tabs__item.is-top.is-active {
      color: red;
    }
  }*/
</style>
<style lang="less">
@tableColor: #F8f8f8; /*table表头背景色*/
@blueColor: #E6A23C; /*收起展开按钮颜色*/
@themeColor: #0dc98e;

::-webkit-scrollbar {
  width: 6px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background-color: #d7d6d6;
  border-radius: 3px;
}

.header_year_picker.el-date-editor.el-input{
  width: 160px !important;
}

.header_year_picker.el-date-editor.el-input .el-input__inner{
  background-color: rgba(255,255,255,0);
  color: #fff;
}

.header_year_picker.el-date-editor.el-input .el-input__icon{
  color: #fff;
}

.big_scr_btn {
  display:flex;
  align-items:center;
  width: 86px;
  height: 30px;
  border-radius: 15px;
  border: 1px solid #dedfe2;
  justify-content: space-evenly;
  box-sizing: border-box;
  padding:0 5px;
  &:hover {
    border: 1px solid #00ffff;
    color: #00ffff;
    cursor: pointer;
  }
  .user_btn_box{
    cursor: pointer;
    color: #fff !important;
  }
}
.el-menu-item.is-active{
  background-color: @themeColor !important;
}

.three_th_inform {
  .el-input{
    width: 200px ;
  }
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 200px;
  }
}

.product_management_box {
    height: 100%;
    width: 100%;
    .el-tabs__content {
      padding: 0 12px;
      height: calc(100% - 46px);
      width: 100%;
      box-sizing: border-box;
      .el-tab-pane {
        height: 100%;
        width: 100%;
        .product_tab_1 {
          /*查询表单样式*/
          .product_filter_form .el-form-item {
            margin: 0;
            width:25%;
          }

          /*table样式*/
          .product_tab_1_table {
            width: 100%;
            position: absolute;

            .el-switch {
              bottom: 3px;
            }

            /*table当前选中行背景色*/
            // .el-table__body tr.current-row > td {
            //   background-color: #FDEDE3;
            // }

            /*table表头背景色*/
            .el-table__header-wrapper .el-table__header th {
              background-color: @tableColor !important;
            }
            /*table固定列表头背景色*/
            .el-table__fixed-header-wrapper .el-table__header th {
              background-color: @tableColor !important;
            }
            /*垂直滚动条上面的补位div背景色*/
            .el-table__fixed-right-patch {
              background-color: @tableColor !important;
            }
          }

          /*展开按钮*/
          .pulldownbox {
            height: 30px;
            width: 100%;

            .pulldownbtn {
              position: relative;
              bottom: 0px;
              margin-left: 10px;
              font-size: 12px;
              color: @blueColor;
              &:hover {
                cursor: pointer;
                color: #78BFF1;
              }
            }
          }

          /*收起按钮*/
          .pullupbtn {
            position: relative;
            bottom: -7px;
            margin-left: 10px;
            font-size: 12px;
            color: #E6A23C;
            &:hover {
              cursor: pointer;
              color: #E6A23C;
            }
          }
          .textInput {
            width :200px;
            height: 40px;
          }
          .small-input .el-form-item__content{
            width: 200px;
          }
          .inline-btn{
            cursor: pointer;
            color: #646464;
          }
          .inline-btn:hover{
            color: #E6A23C;
          }
          .inline-edit-input{
            display:inline-block;
            width:80px;
          }
          .inline-edit-input .el-input__inner{
            padding:0;
          }
        }
        .outer_tab{
          position: relative;
          padding-bottom: 10px;
          box-sizing: border-box;
          width:100%;
          // height:calc(100% - 40px);
          height:100%;
          display: flex;
          flex-direction: column;
        }
        .tablebox{
          width: 100%;
          height: 100%;
          position: relative;
          display: flex;
          flex-direction: column;
            .table-container{
              position: relative;
              flex: 1;
            }
            .count_number{
              color: @themeColor;
            }
            .el-table__fixed-right::before,
            .el-table::before {
              height: 0px;
            }
            .page-row{
              height: 60px;
              width: 100%;
              text-align: center;
              padding-top:10px;
              box-sizing: border-box;
            }
        }
        .expandbox{
          padding-top: 10px;
        }
        .info-container{
          margin-top: 16px;
          background-color: #fff;
          border-radius: 2px;
          box-shadow: -6px 1px 16px 0px rgba(144, 131, 155, 0.13);
        }
      }
      .el-tabs__header{
        padding-left: 20px;
      }
      .el-tabs__content{
        padding: 0;
        height: calc(100% - 40px);
      }
    }
    .el-tabs__header {
      padding: 6px 10px 0 10px;
      background-color: #fff;
      box-shadow: -6px 1px 16px 0px rgba(144, 131, 155, 0.13);
      margin-bottom: 0;
      .el-tabs__nav-wrap::after{
        background-color: #fff;
      }
      /*tab选中下划线颜色*/
      .el-tabs__active-bar.is-top {
        background-color: @themeColor;
      }
      /*tab选中文字颜色*/
      .el-tabs__item.is-top.is-active {
        color: @themeColor;
      }
    }
  }
.project-dialog {
  .el-form-item__content {
    width: 350px;
    .el-upload,.el-select{
      width: 100%;
    }
  }
}
// header中下拉框样式
.project_selector{
  // padding-bottom: 6px;
  position: relative;
  width: 230px;
  height: 32px;
  line-height: 32px;
  font-size: 0;
  .el-icon-s-order{
    position: absolute;
    left:  0;
    font-size: 20px;
    top: 7px;
  }
  .el-select{
    position: absolute;
    right: 0;
    .el-input__inner{
      background-color: rgba(0,0,0,0) !important;
      color: #fff !important;
      border: rgba(0,0,0,0);
      box-sizing: border-box;
    }
    .el-select__caret{
      color: #fff;
    }
  }
}
.customize_star .el-form-item__label::before{
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}

</style>




// WEBPACK FOOTER //
// src/studio/Home.vue